// The University of South Carolina's undergraduate majors (#2652). Read on
// 2026-10-01 from the official 2026-2027 Academic Bulletin's Programs A-Z page
// (academicbulletins.sc.edu/undergraduate/programs-az/): every entry ending in
// a bachelor's degree, grouped by the college in its Bulletin path; minors and
// certificates left out. Left out on purpose: the RN-BSN completion program
// (for licensed nurses) and Palmetto College's Liberal Studies and
// Organizational Leadership degrees (regional campuses or online only). The
// degree abbreviations are the Bulletin's own, including "B.S.C" for the ACS
// certified Chemistry degree and "BARSC" for the Honors College degree. Flags
// quote the School of Music's undergraduate admissions page (the college
// file's `music` source). The KB's majors list was the starting point; the
// Bulletin wins.
const majors = {
    "slug": "university-of-south-carolina",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree in South Carolina's 2026-2027 Academic Bulletin for the Columbia campus, grouped by the college that offers it. Minors, certificates, degree-completion programs and graduate programs are left out.",
    "groups": [
        {
            "name": "McCausland College of Arts and Sciences",
            "source": {
                "label": "South Carolina Academic Bulletin 2026-2027, Programs A-Z",
                "url": "https://academicbulletins.sc.edu/undergraduate/programs-az/"
            },
            "majors": [
                {
                    "name": "African American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Art Education",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Art Studio",
                    "degree": "B.A."
                },
                {
                    "name": "Art Studio",
                    "degree": "B.F.A."
                },
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biological Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Cardiovascular Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S.C"
                },
                {
                    "name": "Criminology and Criminal Justice",
                    "degree": "B.A."
                },
                {
                    "name": "Cyber Intelligence",
                    "degree": "B.S."
                },
                {
                    "name": "Cyber Policy and Ethics",
                    "degree": "B.S."
                },
                {
                    "name": "Dance",
                    "degree": "B.A."
                },
                {
                    "name": "Data Analytics",
                    "degree": "B.S."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.S."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Film and Media",
                    "degree": "B.A."
                },
                {
                    "name": "Geography",
                    "degree": "B.A."
                },
                {
                    "name": "Geography",
                    "degree": "B.S."
                },
                {
                    "name": "Geological Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Global Studies",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "International Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Languages, Literatures and Cultures",
                    "degree": "B.A."
                },
                {
                    "name": "Marine Science",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.S."
                },
                {
                    "name": "Statistics",
                    "degree": "B.S."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Women's and Gender Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Darla Moore School of Business",
            "source": {
                "label": "South Carolina Academic Bulletin 2026-2027, Programs A-Z",
                "url": "https://academicbulletins.sc.edu/undergraduate/programs-az/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Business Economics",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Finance",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "International Business",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Management",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Operations and Supply Chain",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Real Estate",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Risk Management and Insurance",
                    "degree": "B.S.B.A."
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "South Carolina Academic Bulletin 2026-2027, Programs A-Z",
                "url": "https://academicbulletins.sc.edu/undergraduate/programs-az/"
            },
            "majors": [
                {
                    "name": "Applied Sport Psychology and Counseling",
                    "degree": "B.S."
                },
                {
                    "name": "Early Childhood Education",
                    "degree": "B.A."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.A."
                },
                {
                    "name": "Middle Level Education",
                    "degree": "B.A."
                },
                {
                    "name": "Middle Level Education",
                    "degree": "B.S."
                },
                {
                    "name": "Physical Education",
                    "degree": "B.S.P.E."
                },
                {
                    "name": "Special Education",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Molinaroli College of Engineering and Computing",
            "source": {
                "label": "South Carolina Academic Bulletin 2026-2027, Programs A-Z",
                "url": "https://academicbulletins.sc.edu/undergraduate/programs-az/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.A."
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Computer Information Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S.C.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Integrated Information Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S.E."
                }
            ]
        },
        {
            "name": "College of Hospitality, Retail, and Sport Management",
            "source": {
                "label": "South Carolina Academic Bulletin 2026-2027, Programs A-Z",
                "url": "https://academicbulletins.sc.edu/undergraduate/programs-az/"
            },
            "majors": [
                {
                    "name": "Hospitality Management",
                    "degree": "B.S."
                },
                {
                    "name": "Retailing",
                    "degree": "B.S."
                },
                {
                    "name": "Services Management",
                    "degree": "B.A.I.S."
                },
                {
                    "name": "Sport and Entertainment Management",
                    "degree": "B.S."
                },
                {
                    "name": "Tourism Management",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Arnold School of Public Health",
            "source": {
                "label": "South Carolina Academic Bulletin 2026-2027, Programs A-Z",
                "url": "https://academicbulletins.sc.edu/undergraduate/programs-az/"
            },
            "majors": [
                {
                    "name": "Exercise Science",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health",
                    "degree": "B.A."
                },
                {
                    "name": "Public Health",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Information and Communications",
            "source": {
                "label": "South Carolina Academic Bulletin 2026-2027, Programs A-Z",
                "url": "https://academicbulletins.sc.edu/undergraduate/programs-az/"
            },
            "majors": [
                {
                    "name": "Advertising",
                    "degree": "B.A.J.M.C."
                },
                {
                    "name": "Broadcast Journalism",
                    "degree": "B.A.J.M.C."
                },
                {
                    "name": "Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Information Science",
                    "degree": "B.S."
                },
                {
                    "name": "Journalism",
                    "degree": "B.A.J.M.C."
                },
                {
                    "name": "Mass Communications",
                    "degree": "B.A.J.M.C."
                },
                {
                    "name": "Public Relations",
                    "degree": "B.A.J.M.C."
                },
                {
                    "name": "Sports Media",
                    "degree": "B.A."
                },
                {
                    "name": "Visual Communications",
                    "degree": "B.A.J.M.C."
                }
            ]
        },
        {
            "name": "School of Music",
            "source": {
                "label": "South Carolina Academic Bulletin 2026-2027, Programs A-Z",
                "url": "https://academicbulletins.sc.edu/undergraduate/programs-az/"
            },
            "majors": [
                {
                    "name": "Music Industry Studies",
                    "degree": "B.S.",
                    "flag": "Every music applicant also completes the School of Music application and an in-person audition or interview, and must be admitted by both the university and the School of Music.",
                    "flagSource": "music"
                },
                {
                    "name": "Music",
                    "degree": "B.A.",
                    "flag": "Every music applicant also completes the School of Music application and an in-person audition or interview, and must be admitted by both the university and the School of Music.",
                    "flagSource": "music"
                },
                {
                    "name": "Music",
                    "degree": "B.M.",
                    "flag": "Every music applicant also completes the School of Music application and an in-person audition or interview, and must be admitted by both the university and the School of Music.",
                    "flagSource": "music"
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "South Carolina Academic Bulletin 2026-2027, Programs A-Z",
                "url": "https://academicbulletins.sc.edu/undergraduate/programs-az/"
            },
            "majors": [
                {
                    "name": "Nursing-Generic",
                    "degree": "B.S.N."
                }
            ]
        },
        {
            "name": "College of Pharmacy",
            "source": {
                "label": "South Carolina Academic Bulletin 2026-2027, Programs A-Z",
                "url": "https://academicbulletins.sc.edu/undergraduate/programs-az/"
            },
            "majors": [
                {
                    "name": "Pharmaceutical Sciences",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Social Work",
            "source": {
                "label": "South Carolina Academic Bulletin 2026-2027, Programs A-Z",
                "url": "https://academicbulletins.sc.edu/undergraduate/programs-az/"
            },
            "majors": [
                {
                    "name": "Social Work",
                    "degree": "B.S.W."
                }
            ]
        },
        {
            "name": "South Carolina Honors College",
            "source": {
                "label": "South Carolina Academic Bulletin 2026-2027, Programs A-Z",
                "url": "https://academicbulletins.sc.edu/undergraduate/programs-az/"
            },
            "majors": [
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BARSC"
                }
            ]
        }
    ]
};

export default majors;
